/*
 * @Author: Json Chen
 * @Date: 2021-07-15 17:47:30
 * @LastEditTime: 2021-09-29 16:41:13
 * @LastEditors: Teemo Ding
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Logistics/ShippingZone/Components/ShippingZoneModal.tsx
 */

import React, {
  ReactNode,
  useEffect,
  useImperativeHandle,
  useState,
} from 'react';

import { Modal, ModalFooter } from '@/src/components/Antd';
import { CheckCountry } from '@/src/pages/Settings/Components/SelectCountryArea';
import { useRequest } from 'ahooks';
import { Form, Input, Spin } from 'antd';

import InputMaxLength from '@/src/pages/Settings/Components/InputMaxLength';
import {
  getShippingZoneList,
  setShippingZone,
} from '@/src/request/settings/logistics/shippingRate';

import {
  ModalContent,
  //Item as ItemWrapper,
  SectionContainer as Section,
} from 'src/components/Layouts';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import styles from '../css.module.less';

export const useShippingZoneOptionsModal = () => {
  const [selectOptions, setSelectOptions] = useState([]);

  const { loading, run: _getShippingZoneList } = useRequest(
    getShippingZoneList,
    {
      manual: true,
      onSuccess(result) {
        setSelectOptions(result);
      },
    },
  );

  useEffect(() => {
    _getShippingZoneList();
  }, []);

  return {
    loading: loading,
    list: selectOptions,
    reFresh: _getShippingZoneList,
  };
};

const ShippingZoneModal = ({
  list,
  selectOptions,
  children,
  cRef,
  onSuccess,
  initialValues = null,
  modalTitle,
}: {
  list: any[];
  selectOptions: any[];
  children: ReactNode | string;
  onSuccess: () => void;
  initialValues?: any;
  modalTitle: string;
  cRef?: any;
}) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const [form] = Form.useForm();
  const [visiable, setVisiable] = useState<boolean>(false);
  const [disable, setDisable] = useState<boolean>(true);

  const { loading: setShippingZoneLoading, run: _setShippingZone } = useRequest(
    (params) => setShippingZone(params),
    {
      manual: true,
      onSuccess(result) {
        if (result && result.uuid) {
          hideModal();
          onSuccess();
        }
      },
    },
  );

  useImperativeHandle(cRef, () => ({
    showModal: () => {
      setVisiable(true);
      form.resetFields();
    },
  }));

  const showModal = () => {
    setVisiable(true);
  };

  const hideModal = () => {
    setVisiable(false);
    setDisable(true);
  };

  const onModalConfirm = () => {
    form.validateFields().then((res) => {
      const params = { ...res };
      if (initialValues) {
        params.uuid = initialValues.uuid;
      }
      _setShippingZone(params);
    });
  };

  const onFomValuesChange = (_, all) => {
    const { name, countryAreas } = all;
    setDisable(!((name || '').trim() && (countryAreas || []).length));
  };

  return (
    <React.Fragment>
      <div className={styles.button} onClick={showModal}>
        {children}
      </div>
      <Modal
        width={600}
        className={styles.shippingRateModal}
        visible={visiable}
        onCancel={hideModal}
        title={
          modalTitle || getI18n('storeLogistics.shippingZone.addshippingzone')
        }>
        <Spin spinning={setShippingZoneLoading}>
          <ModalContent style={{ maxHeight: 'unset' }}>
            <Section style={{ paddingTop: 0 }}>
              <Form
                form={form}
                className={styles.shippingZoneModal}
                onValuesChange={onFomValuesChange}>
                <Form.Item
                  name='name'
                  initialValue={initialValues ? initialValues.name : ''}
                  className={styles.input}
                  labelCol={{
                    span: 24,
                  }}
                  label={
                    <div className={styles.inputLabel}>
                      <div className={styles.inputLableTitle}>
                        <span className={styles.inputLableTitleName}>
                          {getI18n('storeLogistics.shippingZone.zonename')}*
                        </span>
                        <span className={styles.inputLableTitleDesc}>
                          {getI18n(
                            'storeLogistics.shippingZone.asinternalcomments',
                          )}
                        </span>
                      </div>
                      <InputMaxLength maxLength={100} fieldName='name' />
                    </div>
                  }
                  rules={[
                    { required: true },
                    {
                      validator(_, value) {
                        if (initialValues && initialValues.name === value) {
                          return Promise.resolve();
                        }
                        if (
                          selectOptions.some(
                            (s) =>
                              s.name === value && s.uuid !== initialValues.uuid,
                          )
                        ) {
                          return Promise.reject(
                            new Error(
                              getI18n(
                                'storeLogistics.shippingZone.validZonename',
                              ),
                            ),
                          );
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}>
                  <Input size='large' placeholder='' maxLength={100} />
                </Form.Item>
                <Form.Item
                  name={'countryAreas'}
                  initialValue={
                    initialValues ? initialValues.countryAreas : []
                  }>
                  <CheckCountry list={list} />
                </Form.Item>
              </Form>
            </Section>
          </ModalContent>
          <ModalFooter
            onCancel={hideModal}
            okText={getI18n('general.save')}
            hideOkButton={disable}
            onOk={onModalConfirm}
          />
        </Spin>
      </Modal>
    </React.Fragment>
  );
};

export default ShippingZoneModal;
